/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { elasticSearchMetaSchema } from './elastic-search-meta';
import { lawSchoolSearchResultDtoSchema } from './law-school-search-result-dto';

/** ReadLawSchoolsResponse — dark-roast DTO: SearchLawSchoolResponseDTO */
export const readLawSchoolsResponseSchema = z.object({ "data": z.array(z.lazy(() => lawSchoolSearchResultDtoSchema)), "meta": z.lazy(() => elasticSearchMetaSchema).nullish() });
export type ReadLawSchoolsResponse = z.infer<typeof readLawSchoolsResponseSchema>;
